import './OfferCard.scss';
import * as React from 'react';
import { SearchResultOffer } from 'src/state/SearchResult';
import { getClasses } from 'src/utils/classFunctions';
import { classList } from 'src/utils/classList';
import { ResponsiveImage } from 'src/components/ResponsiveImage';
import { IconChevronRight } from 'src/components/Icon/IconChevronRight';
import { FormattedMessage } from 'react-intl';

type Props = {
    readonly modificators?: ReadonlyArray<string>;
    readonly variant?: string;
    readonly searchItem: SearchResultOffer;
};

function priceEmpty(price: string): boolean {
    return price === 'Gesamt: CHF 0.00';
}

export function OfferCard(props: Props): JSX.Element {
    const { modificators = [], variant, searchItem } = props;
    const { price, discountPrice, priceInformation } = searchItem;

    return (
        <a href={searchItem.searchItem.url}
           target="_blank"
           className={classList(getClasses('lvo-offer-card', modificators), variant)}>
            <div className="lvo-offer-card__img-container lvo-offer-card__img--center">
                <div className="lvo-offer-card__img">
                    <ResponsiveImage src={searchItem.searchItem.image}/>
                </div>
            </div>
            <div className="lvo-offer-card__info-wrapper">
                {searchItem.priceInformation &&
                <div className="lvo-offer-card__package-bundle-text">{priceInformation}</div>
                }
                <h4 className="lvo-offer-card__title">
                    {searchItem.searchItem.title}
                </h4>
                <div className="lvo-offer-card__button-wrapper">
                    <div className="lvo-offer-card__price">
                        {searchItem.price &&
                        <div className="icon-box">
                            <IconChevronRight/>
                        </div>
                        }
                        {price &&
                            priceEmpty(price) ? <FormattedMessage id={'searchPage_priceFree'} /> : price
                        }
                        {discountPrice !== null &&
                            <del>{discountPrice}</del>
                        }
                    </div>
                    <a href={searchItem.searchItem.url} className="lvo-offer-card__btn">
                        <FormattedMessage id={'searchPage_bookNow'} />
                    </a>
                </div>
            </div>
        </a>
    );
}
